module.exports = __webpack_public_path__ + "static/media/uova.c1e2b134.svg";